import React from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'components/Button';
import styles from '../Membership.module.scss';

interface ConfirmDeleteSectionModalProps {
  show: boolean;
  onHide: () => void;
  sectionLabel: string;
  onConfirm: () => void;
}

function ConfirmDeleteSectionModal({
  show,
  onHide,
  sectionLabel,
  onConfirm,
}: ConfirmDeleteSectionModalProps) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      className={styles.modal}
      contentClassName={styles.modalContent}
      dialogClassName={styles.modalDialog}
      backdrop="static"
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <Modal.Title className={styles.modalTitle}>Delete section</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <p>
          Are you sure you want to delete this <strong>{sectionLabel}</strong>{' '}
          section? This cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer className={styles.modalFooter}>
        <Button type="button" variant="outline" onClick={onHide}>
          Cancel
        </Button>
        <Button
          type="button"
          onClick={onConfirm}
          className={styles.deleteButton}
        >
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ConfirmDeleteSectionModal;
